<template>
  <div class="search">
    <div class="search-banner">
      <div class="container">
        <h1 class="search-banner__title">Search</h1>
      </div>
    </div>
    <div class="search-main">
      <div class="container">
        <div class="search-result__header__left" style="margin-bottom: 20px">
          <button
            :class="{
              'search-result__filter__btn__active': tfType === 'TF',
            }"
            class="search-result__filter__btn"
            @click="handleChangeTfType('TF')"
          >
            <i class="el-icon el-icon"></i>TF Family
          </button>
          <button
            :class="{
              'search-result__filter__btn__active': tfType === 'TF Cof',
            }"
            class="search-result__filter__btn"
            @click="handleChangeTfType('TF Cof')"
          >
            TF-RLs
          </button>
          <button
            :class="{
              'search-result__filter__btn__active': tfType === 'TF Target',
            }"
            class="search-result__filter__btn"
            @click="handleChangeTfType('TF Target')"
          >
            <i class="el-icon el-icon"></i>TF Target
          </button>
        </div>
        <div class="search-mode-selector">
          <div
            :class="{
              active: activeMode === 'keyword',
            }"
            class="search-mode-item"
            @click="toggleSearchMode('keyword')"
          >
            Search by keyword
          </div>
          <div
            :class="{
              active: activeMode === 'category',
            }"
            class="search-mode-item"
            @click="toggleSearchMode('category')"
          >
            Search by category
          </div>
        </div>
        <div v-show="activeMode === 'keyword'" class="search-box-wrapper">
          <div class="search-box">
            <input
              v-model="searchInput"
              class="search-box__input"
              placeholder="Input TF name, Species, Ensembl ID, UniProt ID or any other keyword."
              type="text"
              @keyup.enter="handleSearch"
            />
            <button class="search-box__btn" @click="handleSearch">
              <i class="el-icon el-icon-search"></i>
            </button>
          </div>
        </div>
        <div v-show="activeMode === 'keyword'" class="search-hot">
          <p class="search-hot__list">
            Hot search terms：<span
              v-for="item in searchHotList"
              :key="item"
              @click="handleSearchHot(item)"
            >
              {{ item }}
            </span>
          </p>
        </div>
        <div v-show="activeMode === 'category'" class="search-panel">
          <el-form
            v-loading="initOptionsLoading"
            class="search-form"
            label-position="top"
          >
            <el-row :gutter="50" class="search-form__row">
              <template v-if="tfType === 'TF' || tfType === 'TF Target'">
                <el-col
                  v-for="option in optionKeyList"
                  :key="option.label"
                  :span="8"
                >
                  <el-form-item :label="option.label">
                    <ElSelectV2
                      v-model="searchFormCategory[option.key]"
                      :options="options[option.key + 'Options']"
                      clearable
                      filterable
                      placeholder="Please Select"
                      style="width: 100%"
                    ></ElSelectV2>
                    <!--                  <el-select
                      v-model="searchFormCategory[option.key]"
                      v-loading="initOptionsLoading"
                      clearable
                      placeholder="Please Select"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="option in options[option.key + 'Options']"
                        :key="option.label"
                        :label="option.label"
                        :value="option.value"
                      ></el-option>
                    </el-select>-->
                  </el-form-item>
                </el-col>
              </template>
              <template v-else>
                <el-col
                  v-for="option in optionKeyTFCOLList"
                  :key="option.label"
                  :span="8"
                >
                  <el-form-item :label="option.label">
                    <ElSelectV2
                      v-model="searchFormCategory[option.key]"
                      :options="colOptions[option.key + 'Options']"
                      clearable
                      filterable
                      placeholder="Please Select"
                      style="width: 100%"
                    ></ElSelectV2>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
            <el-row>
              <el-col :offset="8" :span="8" style="text-align: center">
                <el-button
                  :disabled="searchLoading"
                  :loading="searchBtnLoading"
                  type="primary"
                  @click="handleSearch"
                >
                  Submit
                </el-button>
                <el-button
                  :disabled="searchLoading"
                  :loading="resetBtnLoading"
                  @click="handleResetCategory"
                >
                  Reset
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div
          v-show="activeMode === 'keyword'"
          v-loading="searchLoading"
          class="search-result"
        >
          <div class="search-result__header">
            <div class="search-result__header__left"></div>
            <div class="search-result__header__right">
              <div class="search-box">
                <input
                  v-model="filterInput"
                  class="search-box__input"
                  placeholder="Filter by species, gene id or gene symbol from current results."
                  type="text"
                />
                <button class="search-box__btn">
                  <i class="el-icon el-icon-search"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="search-result__body">
            <el-table :data="tableDataShow" border style="width: 100%">
              <template v-if="tfType === 'TF' || tfType === 'TF Target'">
                <el-table-column
                  label="Ensembl ID"
                  prop="ensemblId"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  label="Gene ID"
                  prop="geneId"
                ></el-table-column>
                <!-- <el-table-column label="Gene Symbol" prop="geneSymbol">
                </el-table-column> -->
                <el-table-column label="Family" prop="tfFamilies">
                </el-table-column>
                <el-table-column label="Species" min-width="140" prop="species">
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column
                  label="TF Name"
                  prop="tfName"
                ></el-table-column>
                <el-table-column
                  label="TF-RLs Name"
                  prop="tfCofName"
                  width="180"
                >
                </el-table-column>
                <el-table-column label="Species" min-width="140" prop="species">
                </el-table-column>
                <el-table-column label="Fomula" prop="fomula">
                </el-table-column>
                <el-table-column label="External Id" prop="externalId">
                </el-table-column>
              </template>
              <el-table-column align="center" label="Details">
                <template v-slot="{ row }">
                  <el-button type="text" @click="handleView(row)">
                    View
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="search-result__footer">
            <el-button
              :loading="exportBtnLoading"
              style="border-radius: 50px"
              type="success"
              @click="handleExport"
            >
              Export
            </el-button>
            <el-pagination
              :current-page.sync="pageInfo.page"
              :page-size="pageInfo.pageSize"
              :total="pageInfo.total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>

        <div
          v-show="activeMode === 'category'"
          v-loading="searchLoading"
          class="search-result"
        >
          <div class="search-result__header">
            <div class="search-result__header__left"></div>
            <div class="search-result__header__right">
              <div class="search-box">
                <input
                  v-model="filterInput"
                  class="search-box__input"
                  placeholder="Filter by species, gene id or gene symbol from current results."
                  type="text"
                />
                <button class="search-box__btn">
                  <i class="el-icon el-icon-search"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="search-result__body">
            <el-table :data="tableDataShow" border style="width: 100%">
              <template v-if="tfType === 'TF' || tfType === 'TF Target'">
                <el-table-column
                  label="Ensembl ID"
                  prop="ensemblId"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  label="Gene ID"
                  prop="geneId"
                ></el-table-column>
                <!-- <el-table-column label="Gene Symbol" prop="geneSymbol">
                </el-table-column> -->
                <el-table-column label="Family" prop="tfFamilies">
                </el-table-column>
                <el-table-column label="Species" min-width="140" prop="species">
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column label="TF Name" prop="tfName">
                </el-table-column>
                <el-table-column
                  label="TF-RLs Name"
                  prop="tfCofName"
                ></el-table-column>
                <el-table-column label="Species" min-width="140" prop="species">
                </el-table-column>
                <el-table-column label="External Id" prop="externalId">
                </el-table-column>
                <el-table-column label="pubchem Cid" prop="pubchemCid">
                </el-table-column>
                <el-table-column label="pubchem Sid" prop="pubchemSid">
                </el-table-column>
              </template>
              <el-table-column align="center" label="Details">
                <template v-slot="{ row }">
                  <el-button type="text" @click="handleView(row)">
                    View
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="search-result__footer">
            <el-button
              :loading="exportBtnLoading"
              style="border-radius: 50px"
              type="success"
              @click="handleExport"
            >
              Export
            </el-button>
            <el-pagination
              :current-page.sync="pageInfo.page"
              :page-size="pageInfo.pageSize"
              :total="pageInfo.total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingMixins from "@/mixins/loadingMixins";
import {
  cofinitList,
  exportFilteredData,
  exportSearchResults,
  exportTfCofFilteredData,
  exportTfTargetData,
  exportTfTarget,
  filter,
  filterTfCof,
  filterTfTarget,
  getPopularWords,
  initList,
  search,
  searchTfCof,
  searchTfTarget,
  tfCofExportSearchResults,
} from "@/api/search";

export default {
  name: "SearchView",
  mixins: [loadingMixins],
  data() {
    return {
      searchLoading: false,
      searchBtnLoading: false,
      resetBtnLoading: false,
      initOptionsLoading: false,
      activeMode: "keyword", // keyword or category
      searchFormCategory: {
        species: "",
        tfName: "",
        // tfType: "",
        // type: "",
        ensemblId: "",
        geneId: "",
        transcriptId: "",
        proteinId: "",
        uniprotId: "",
        sourceId: "",
      },
      tfType: "TF",
      optionKeyList: [
        {
          label: "Species",
          key: "species",
        },
        // {
        //   label: "Search Type",
        //   key: "tfType",
        // },
        {
          label: "TF Name",
          key: "tfName",
        },
        {
          label: "Ensembl ID",
          key: "ensemblId",
        },
        // {
        //   label: "Type",
        //   key: "type",
        // },
        {
          label: "Gene ID",
          key: "geneId",
        },
        {
          label: "Transcript ID",
          key: "transcriptId",
        },
        {
          label: "Protein ID",
          key: "proteinId",
        },
        {
          label: "Uniprot ID",
          key: "uniprotId",
        },
        {
          label: "Source ID",
          key: "sourceId",
        },
      ],
      optionKeyTFCOLList: [
        {
          label: "TF Name",
          key: "tfName",
        },
        {
          label: "TF-RLs Name",
          key: "tfCofName",
        },
        {
          label: "Species",
          key: "species",
        },
        {
          label: "External Id",
          key: "externalId",
        },
        {
          label: "Pubchem Cid",
          key: "pubchemCid",
        },
        {
          label: "Pubchem Sid",
          key: "pubchemSid",
        },
      ],
      colOptions: {
        tfNameOptions: [],
        tfCofNameOptions: [],
        speciesOptions: [],
        externalIdOptions: [],
        pubchemCidOptions: [],
        pubchemSidOptions: [],
      },
      options: {
        speciesOptions: [],
        tfTypeOptions: [
          {
            label: "TF",
            value: "TF",
          },
          {
            label: "TF Cof",
            value: "TF Cof",
          },
        ],
        tfNameOptions: [],
        ensemblIdOptions: [],
        typeOptions: [],
        geneIdOptions: [],
        transcriptIdOptions: [],
        proteinIdOptions: [],
        uniprotIdOptions: [],
        sourceIdOptions: [],
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      searchInput: "",
      filterInput: "",
      tableDataKeyword: [],
      tableDataCategory: [],
      searchHotList: [],
      exportBtnLoading: false,
    };
  },
  mounted() {
    // 获取下拉列表
    this.initOptions();
    // 获取热搜关键词
    this.initHotTerms();
    this.searchInput = this.$route.query.search || "";
    this.handleSearch();
  },
  computed: {
    tableDataShow() {
      const dataType =
        this.activeMode === "keyword"
          ? this.tableDataKeyword
          : this.tableDataCategory;
      return dataType.filter((item) => {
        if (item === "") {
          return true;
        } else {
          return (
            item.species
              ?.toLowerCase()
              ?.includes(this.filterInput.toLowerCase()) ||
            item.geneId
              ?.toLowerCase()
              ?.includes(this.filterInput.toLowerCase()) ||
            item.geneSymbol
              ?.toLowerCase()
              ?.includes(this.filterInput.toLowerCase())
          );
        }
      });
    },
  },
  methods: {
    startLoading() {
      this.loadingMixins__startLoading().then(() => {
        this.searchLoading = true;
      });
    },
    endLoading() {
      this.loadingMixins__endLoading().then(() => {
        this.searchLoading = false;
        this.searchBtnLoading = false;
        this.resetBtnLoading = false;
      });
    },
    toggleSearchMode() {
      if (this.activeMode === "keyword") {
        this.activeMode = "category";
      } else {
        this.activeMode = "keyword";
      }
      this.handleSearch();
    },
    filterOptions(options) {
      options = options || [];
      const filteredOptions = [];
      options.forEach((item) => {
        if (item) {
          filteredOptions.push({
            label: item,
            value: item,
          });
        }
      });
      return filteredOptions;
    },
    initHotTerms() {
      getPopularWords().then((res) => {
        this.searchHotList = res.data;
      });
    },
    // 获取下拉列表
    initOptions() {
      this.initOptionsLoading = true;
      initList()
        .then((res) => {
          const options = {
            speciesOptions: [],
            tfTypeOptions: [
              {
                label: "TF",
                value: "TF",
              },
              {
                label: "TF Cof",
                value: "TF Cof",
              },
            ],
            tfNameOptions: [],
            ensemblIdOptions: [],
            typeOptions: [],
            geneIdOptions: [],
            transcriptIdOptions: [],
            proteinIdOptions: [],
            uniprotIdOptions: [],
            sourceIdOptions: [],
          };
          options.speciesOptions = this.filterOptions(res.data.species);
          options.tfNameOptions = this.filterOptions(res.data.tfName);
          options.ensemblIdOptions = this.filterOptions(res.data.ensembl_id);
          options.typeOptions = this.filterOptions(res.data.type);
          options.geneIdOptions = this.filterOptions(res.data.gene_id);
          options.transcriptIdOptions = this.filterOptions(
            res.data.transcript_id
          );
          options.proteinIdOptions = this.filterOptions(res.data.protein_id);
          options.uniprotIdOptions = this.filterOptions(
            res.data.uniprot_k_b_id
          );
          options.sourceIdOptions = this.filterOptions(res.data.sourceId);
          this.$set(this, "options", options);
        })
        .finally(() => {
          this.initOptionsLoading = false;
        });
      cofinitList().then((res) => {
        console.log(111, res.data);
        const colOptions = {
          tfNameOptions: [],
          tfCofNameOptions: [],
          speciesOptions: [],
          externalIdOptions: [],
          pubchemCidOptions: [],
          pubchemSidOptions: [],
        };
        colOptions.tfNameOptions = this.filterOptions(res.data.tfName);
        colOptions.tfCofNameOptions = this.filterOptions(res.data.tfCofName);
        colOptions.speciesOptions = this.filterOptions(res.data.species);
        colOptions.externalIdOptions = this.filterOptions(res.data.externalId);
        colOptions.pubchemCidOptions = this.filterOptions(res.data.pubchemCid);
        colOptions.pubchemSidOptions = this.filterOptions(res.data.pubchemSid);
        this.$set(this, "colOptions", colOptions);
      });
    },
    getTableData() {
      this.startLoading();

      // 定义接口映射关系
      const apiMap = {
        category: {
          TF: filter,
          "TF Cof": filterTfCof,
          "TF Target": filterTfTarget,
        },
        keyword: {
          TF: search,
          "TF Cof": searchTfCof,
          "TF Target": searchTfTarget,
        },
      };

      // 根据当前模式和类型选择对应的接口
      const currentApi = apiMap[this.activeMode][this.tfType];

      // 构造请求参数
      const params =
        this.activeMode === "category"
          ? {
              page: this.pageInfo.page,
              limit: this.pageInfo.pageSize,
              data: this.searchFormCategory,
            }
          : {
              keyword: this.searchInput,
              page: this.pageInfo.page,
              limit: this.pageInfo.pageSize,
            };

      // 执行请求
      currentApi(params)
        .then((res) => {
          // 根据模式设置对应的数据
          if (this.activeMode === "category") {
            this.tableDataCategory = res.data.data;
            this.pageInfo.total = res.data.count;
          } else {
            this.tableDataKeyword = res.data;
            this.pageInfo.total = res.count;
          }
        })
        .finally(() => {
          this.endLoading();
        });
    },
    handleSearch() {
      this.pageInfo.page = 1;
      this.getTableData();
    },
    handleResetCategory() {
      this.resetBtnLoading = true;
      if (this.tfType === "TF" || this.tfType === "TF Target") {
        this.searchFormCategory = {
          species: "",
          tfName: "",
          // tfType: "",
          // type: "",
          ensemblId: "",
          geneId: "",
          transcriptId: "",
          proteinId: "",
          uniprotId: "",
          sourceId: "",
        };
      } else {
        this.searchFormCategory = {
          species: "",
          tfName: "",
          tfCofName: "",
          externalId: "",
          pubchemCid: "",
          pubchemSid: "",
        };
      }
      this.filterInput = "";
      this.getTableData();
    },
    handleSearchHot(searchHot) {
      this.searchInput = searchHot;
      this.handleSearch();
    },
    handleCurrentChange() {
      this.getTableData();
    },
    handleView(row) {
      if (this.tfType === "TF" || this.tfType === "TF Target") {
        const { href } = this.$router.resolve({
          path: "/detail",
          query: {
            id: row.id,
            tfType: this.tfType,
          },
        });
        window.open(href);
      } else {
        const { href } = this.$router.resolve({
          path: "/cofDetail",
          query: {
            id: row.id,
          },
        });
        window.open(href);
      }
    },
    downloadCSV(csvContent, fileName) {
      const blob = new Blob([csvContent], { type: "text/csv" });
      const link = document.createElement("a");

      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },

    handleExport() {
      this.$message.info("start downloading, please wait a moment");
      try {
        this.exportBtnLoading = true;
        // 定义导出接口映射关系
        const exportApiMap = {
          category: {
            TF: exportFilteredData,
            "TF Cof": exportTfCofFilteredData,
            "TF Target": exportTfTargetData,
          },
          keyword: {
            TF: exportSearchResults,
            "TF Cof": tfCofExportSearchResults,
            "TF Target": exportTfTarget,
          },
        };
        // 根据当前模式和类型选择对应的导出接口
        const downloadAPI = exportApiMap[this.activeMode][this.tfType];
        // 构造导出数据
        const data =
          this.activeMode === "category"
            ? this.searchFormCategory
            : this.searchInput;
        downloadAPI(data, this.pageInfo.page, this.pageInfo.pageSize).then(
          (res) => {
            const now = new Date();
            const fileName = `download_${now.getFullYear()}${
              now.getMonth() + 1
            }${now.getDate()}_${now.getHours()}${now.getMinutes()}${now.getSeconds()}.csv`;
            this.downloadCSV(res, fileName);
          }
        );
      } finally {
        setTimeout(() => {
          this.exportBtnLoading = false;
        }, 1500);
      }
    },
    handleChangeTfType(TFOrTfCof) {
      if (this.tfType !== TFOrTfCof) {
        this.pageInfo.page = 1;
        this.searchInput = "";
        if (TFOrTfCof === "TF" || TFOrTfCof === "TF Target") {
          this.searchFormCategory = {
            species: "",
            tfName: "",
            ensemblId: "",
            geneId: "",
            transcriptId: "",
            proteinId: "",
            uniprotId: "",
            sourceId: "",
          };
        } else {
          this.searchFormCategory = {
            species: "",
            tfName: "",
            tfCofName: "",
            externalId: "",
            pubchemCid: "",
            pubchemSid: "",
          };
        }
        this.filterInput = "";
        this.tfType = TFOrTfCof;
      }
      this.handleSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  .search-banner {
    height: px2rem(300);
    background-image: url("~@/assets/search/banner.webp");
    background-size: cover;
    background-position: bottom center;
    display: flex;
    align-items: center;
  }

  .search-banner__title {
    color: #fff;
  }

  .search-main {
    padding: px2rem(60) px2rem(0) px2rem(200) px2rem(0);
  }

  .search-mode-selector {
    display: flex;
    align-items: center;
    margin-bottom: px2rem(20);
    user-select: none;

    .search-mode-item {
      padding: px2rem(12) px2rem(16);
      border: 1px solid $--color-text-placeholder;
      border-radius: $--border-radius-base;
      cursor: pointer;
      color: $--color-text-regular;
      font-size: px2rem(14);

      &:first-child {
        border-right: 0;
        border-radius: $--border-radius-base 0 0 $--border-radius-base;
      }

      &:last-child {
        border-radius: 0 $--border-radius-base $--border-radius-base 0;
      }

      &.active {
        background-color: $--color-secondary;
        color: $--color-white;
      }
    }
  }

  .search-box-wrapper {
    .search-box {
      border: 1px solid $--color-text-placeholder;
      margin-bottom: px2rem(20);
    }
  }

  .search-hot {
    font-size: px2rem(14);
    padding-left: px2rem(18);
    margin-bottom: px2rem(60);
  }

  .search-hot__list {
    color: $--color-text-placeholder;

    span {
      color: $--color-secondary;
      margin-right: px2rem(8);
      cursor: pointer;
    }
  }

  .search-panel {
    padding: px2rem(20);
    box-shadow: 0 0 px2rem(10) 0 rgba(0, 0, 0, 0.1);
    border-radius: px2rem(6);
    margin-bottom: px2rem(60);
  }

  .search-form__row {
    margin-bottom: px2rem(50);
  }

  .search-result {
    box-shadow: 0 0 px2rem(10) 0 rgba(0, 0, 0, 0.1);
    border-radius: px2rem(6);
  }

  .search-result__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: px2rem(30) px2rem(30);
    border-bottom: px2rem(1) solid #cccccc;
  }

  .search-result__header__left {
    .search-result__filter__btn {
      background: #cccccc;
      border: none;
      padding: px2rem(10) px2rem(20);
      border-radius: px2rem(4);
      margin-right: px2rem(10);
      color: #fff;
      font-size: px2rem(14);
      transition: $--all-transition;

      &:hover {
        background-color: $--color-secondary;
      }

      &__active {
        background-color: $--color-secondary;
      }
    }
  }

  .search-result__header__right {
    .search-box {
      width: px2rem(500);
      box-shadow: 0 0 px2rem(10) 0 rgba(0, 0, 0, 0.1);
    }
  }

  .search-result__body {
    padding: px2rem(30) px2rem(30) 0 px2rem(30);
  }

  .search-result__footer {
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: px2rem(30) px2rem(30);
  }
}

::v-deep .el-table th.el-table__cell {
  background-color: #f5f8ff;
}

::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 0;
}

::v-deep .el-pagination {
  display: flex;
  align-items: center;
}
</style>
